<template>
  <v-chip
    :small='$vuetify.breakpoint.smAndDown || small'
    dark
    color='purple'
  >
    <v-icon
      left
      :small='$vuetify.breakpoint.smAndDown || small'
    >mdi-information</v-icon>
    Non-Capital Install
  </v-chip>
</template>

<script>
export default {
  name: 'is-capital-install',
  props: {
    small: {
      required: false,
      type: Boolean,
      default: false
    }
  }
}
</script>
